module.exports = __webpack_public_path__ + "img/215-8ce430.png";